import React from 'react'

import SettingsPage from '../SettingsPage'
import TypeSettings from './TypeSettings'
import CategorySettings from './CategorySettings'
import CategoryRulesSettings from './CategoryRulesSettings'
import StatusSettings from './StatusSettings'
import PrioritySettings from './PrioritySettings'

const TaskSettings = () => (
  <SettingsPage title='Tasks'>
    <CategorySettings />

    <TypeSettings />

    <CategoryRulesSettings />

    <StatusSettings />

    <PrioritySettings />
  </SettingsPage>
)

export default TaskSettings
